var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarHalf = function SvgStarHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    className: "star-half_svg___icon_7rbmn_1",
    width: "1em",
    height: "1em",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#star-half_svg__a)",
    className: "star-half_svg__Half star-half_svg__Star star-half_svg__24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC220",
    d: "M10.713.836a1.408 1.408 0 0 1 2.574 0l2.596 5.498c.21.443.613.75 1.08.82l5.807.882c1.177.179 1.647 1.69.795 2.558l-4.201 4.28a1.54 1.54 0 0 0-.413 1.327l.992 6.043c.2 1.225-1.03 2.159-2.082 1.58l-5.193-2.853a1.38 1.38 0 0 0-1.336 0L6.14 23.824c-1.053.579-2.283-.355-2.082-1.58L5.05 16.2a1.542 1.542 0 0 0-.413-1.328l-4.201-4.28c-.852-.867-.382-2.378.795-2.557l5.806-.882a1.441 1.441 0 0 0 1.08-.82L10.714.836Z",
    className: "star-half_svg__Fill-Main"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    d: "M15.883 6.334 13.287.836A1.413 1.413 0 0 0 12 0v21s.25-.258.668-.029l5.193 2.854c1.052.578 2.283-.356 2.082-1.581L18.95 16.2c-.08-.487.075-.983.413-1.328l4.201-4.28c.852-.867.382-2.378-.795-2.557l-5.806-.882a1.441 1.441 0 0 1-1.08-.82Z",
    className: "star-half_svg__Fill-Secondary"
  }))));
};
export default SvgStarHalf;